import React from "react";
import EADialog from "../../EADialog";
import EATextField from "../../EATextField";
import EAButtonBar from "../../EAButtonBar";
import EAButton from "../../EAButton";

const id = "betriebsdatenFreigabeDialog";

const MAX_KOMMENTAR_LENGTH = 500;

function FreigabeDialog({ label, open, onClose, kommentar, onKommentarChange, onFreigabe, onAblehnen, freigabeLabel = "Freigeben" }) {
    const handleKommentarChange = (e) => {
        const value = e.target.value.slice(0, MAX_KOMMENTAR_LENGTH);
        onKommentarChange({
            ...e,
            target: {
                ...e.target,
                value,
            },
        });
    };

    return (
        <EADialog
            open={open}
            closeFunction={onClose}
            titleChildren={label + " freigeben / zurückweisen"}
            content={
                <EATextField
                    value={kommentar}
                    onChange={handleKommentarChange}
                    label="Kommentar"
                    multiline
                    rows={10}
                    id={id + "-kommentar"}
                    className="w-100"
                    inputProps={{ maxLength: MAX_KOMMENTAR_LENGTH }}
                    helperText={`${kommentar.length}/${MAX_KOMMENTAR_LENGTH}`}
                />
            }
            buttons={
                <EAButtonBar style={{ width: "800px" }}>
                    <EAButton id={id + "-ablehnen"} label={"Zurückweisen"} onClick={onAblehnen} disabled={!kommentar.trim()} />
                    <EAButton id={id + "-freigeben"} label={freigabeLabel} onClick={onFreigabe} color="primary" />
                </EAButtonBar>
            }
        />
    );
}

export default FreigabeDialog;
